export const media = {
  tablet: "@media(min-width :767px)",
  desktop: "@media(min-width :1025px)",
  large: "@media(min-width :1225px)",
};
